"use client";

import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Presence() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const address = "400 Industrial Way, Suite 10, Detroit, MI, 48201";
  const phone = "(313) 555-0199";
  const email = "ops@metpropartners.com";
  const phoneTel = "+13135550199";
  const mapsQuery = encodeURIComponent(address);
  const mapEmbedUrl = `https://www.google.com/maps?q=${mapsQuery}&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${mapsQuery}`;
  const infoRows = [{
    label: "Headquarters",
    content: <p className="text-base leading-relaxed text-foreground/75">
          400 Industrial Way, Suite 10
          <br />
          Detroit, MI 48201
          <br />
          United States
        </p>
  }, {
    label: "Operations",
    content: <p className="text-base leading-relaxed text-foreground/75">
          Monday – Friday: 08:00 – 17:00 EST
          <br />
          Technical support available on-call
          <br />
          Saturday & Sunday: Closed
        </p>
  }, {
    label: "Direct Line",
    content: <div className="flex flex-col gap-2">
          <Link to={`tel:${phoneTel}`} className="group relative inline-flex w-fit items-center text-base text-foreground transition-colors hover:text-accent">
            <span>{phone}</span>
            <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-accent transition-all duration-[260ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:w-full" />
          </Link>
          <Link to={`mailto:${email}`} className="group relative inline-flex w-fit items-center text-base text-foreground transition-colors hover:text-accent">
            <span>{email}</span>
            <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-accent transition-all duration-[260ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:w-full" />
          </Link>
        </div>
  }];
  return;
}